import { cn } from "../../lib/cn";

function scoreVariant(value) {
  if (value == null || Number.isNaN(Number(value))) return "muted";
  const n = Number(value);
  if (n >= 90) return "success";
  if (n >= 50) return "warning";
  return "destructive";
}

const ringColors = {
  success: "stroke-green-500",
  warning: "stroke-amber-500",
  destructive: "stroke-red-500",
  muted: "stroke-muted-foreground/30",
};

const textColors = {
  success: "text-green-600",
  warning: "text-amber-600",
  destructive: "text-red-600",
  muted: "text-muted-foreground",
};

export function Score({ value, label, size = "md", className }) {
  const num = value != null ? Math.round(Number(value)) : null;
  const variant = scoreVariant(num);
  const display = num != null && !Number.isNaN(num) ? num : "–";

  const dims = {
    xs: { box: "w-[4.25rem] h-[4.25rem] sm:w-20 sm:h-20", text: "text-base sm:text-xl", ring: 56, stroke: 4 },
    sm: { box: "w-20 h-20", text: "text-xl", ring: 56, stroke: 4 },
    md: { box: "w-28 h-28 sm:w-32 sm:h-32", text: "text-3xl sm:text-4xl", ring: 88, stroke: 5 },
    lg: { box: "w-36 h-36", text: "text-5xl", ring: 120, stroke: 6 },
  }[size] || { box: "w-28 h-28", text: "text-3xl", ring: 88, stroke: 5 };

  const r = (dims.ring - dims.stroke) / 2;
  const circumference = 2 * Math.PI * r;
  const offset =
    num != null && !Number.isNaN(num)
      ? circumference - (num / 100) * circumference
      : circumference;

  return (
    <div className={cn("flex flex-col items-center gap-2", className)}>
      <div className={cn("relative", dims.box)}>
        <svg className="w-full h-full -rotate-90" viewBox={`0 0 ${dims.ring} ${dims.ring}`}>
          <circle
            cx={dims.ring / 2}
            cy={dims.ring / 2}
            r={r}
            fill="none"
            className="stroke-muted"
            strokeWidth={dims.stroke}
          />
          {num != null && !Number.isNaN(num) && (
            <circle
              cx={dims.ring / 2}
              cy={dims.ring / 2}
              r={r}
              fill="none"
              className={ringColors[variant]}
              strokeWidth={dims.stroke}
              strokeLinecap="round"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
            />
          )}
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span
            className={cn(
              "font-semibold tabular-nums tracking-tight",
              dims.text,
              textColors[variant]
            )}
          >
            {display}
          </span>
        </div>
      </div>
      {label && (
        <span
          className={cn(
            "font-medium text-muted-foreground text-center",
            size === "xs"
              ? "text-[10px] sm:text-xs leading-tight px-0.5"
              : "text-xs sm:text-sm",
          )}
        >
          {label}
        </span>
      )}
    </div>
  );
}
